interface ConnectionStatusBadgeProps {
	status: string
}

export const ConnectionStatusBadge = ({status}: ConnectionStatusBadgeProps) => {
	const statusMap = {
		connected: {
			text: "Connected",
			color: "text-green-600 bg-green-100 dark:text-green-300 dark:bg-green-900/40",
		},
		disconnected: {
			text: "Disconnected",
			color: "text-red-600 bg-red-100 dark:text-red-300 dark:bg-red-900/40",
		},
		unknown: {
			text: "Unknown",
			color: "text-gray-600 bg-gray-100 dark:text-gray-300 dark:bg-gray-700",
		},
	}

	const config = statusMap[status as keyof typeof statusMap] || statusMap.unknown

	return (
		<span className={`px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
			{config.text}
		</span>
	)
}

interface FwStatusBadgeProps {
	status: string
}

export const FwStatusBadge = ({status}: FwStatusBadgeProps) => {
	const isIdle = status.toLowerCase() === "idle"
	return (
		<span
			className={`px-2 py-1 rounded-full text-xs font-medium ${
				isIdle
					? "text-green-600 bg-green-100 dark:text-green-300 dark:bg-green-900/40"
					: "text-yellow-600 bg-yellow-100 dark:text-yellow-300 dark:bg-yellow-900/40"
			}`}>
			{status}
		</span>
	)
}

interface UploadStatusBadgeProps {
	status?: string
	error?: string
}

export const UploadStatusBadge = ({status, error}: UploadStatusBadgeProps) => {
	if (error) {
		return (
			<span className="px-2 py-1 rounded-full text-xs font-medium text-red-600 bg-red-100 dark:text-red-300 dark:bg-red-900/40">
				Failed
			</span>
		)
	}

	if (!status) {
		return (
			<span className="px-2 py-1 rounded-full text-xs font-medium text-gray-600 bg-gray-100 dark:text-gray-300 dark:bg-gray-700">
				N/A
			</span>
		)
	}

	const statusMap: Record<string, {text: string; color: string}> = {
		QUEUED: {
			text: "Queued",
			color: "text-blue-600 bg-blue-100 dark:text-blue-300 dark:bg-blue-900/40",
		},
		IN_PROGRESS: {
			text: "In Progress",
			color: "text-yellow-600 bg-yellow-100 dark:text-yellow-300 dark:bg-yellow-900/40",
		},
		SUCCEEDED: {
			text: "Succeeded",
			color: "text-green-600 bg-green-100 dark:text-green-300 dark:bg-green-900/40",
		},
		FAILED: {
			text: "Failed",
			color: "text-red-600 bg-red-100 dark:text-red-300 dark:bg-red-900/40",
		},
		NOT_FOUND: {
			text: "Not Found",
			color: "text-gray-600 bg-gray-100 dark:text-gray-300 dark:bg-gray-700",
		},
		ERROR: {
			text: "Error",
			color: "text-red-600 bg-red-100 dark:text-red-300 dark:bg-red-900/40",
		},
	}

	const config = statusMap[status] || {
		text: status,
		color: "text-gray-600 bg-gray-100 dark:text-gray-300 dark:bg-gray-700",
	}

	return (
		<span className={`px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
			{config.text}
		</span>
	)
}
